export default {
  /* S3 data */
  AWS_GET_S3_DATA: 'AWS_GET_S3_DATA',
  AWS_GET_S3_DATA_SUCCESS: 'AWS_GET_S3_DATA_SUCCESS',
  AWS_GET_S3_DATA_ERROR: 'AWS_GET_S3_DATA_ERROR',

  /* Dates */
  AWS_SET_S3_DATES: 'AWS_SET_S3_DATES',
  AWS_CLEAR_S3_DATES: 'AWS_CLEAR_S3_DATES',

  /* LocalStorage */
  AWS_LOAD_S3_DATES: 'AWS_LOAD_S3_DATES',
  AWS_LOAD_S3_DATES_ERROR: 'AWS_LOAD_S3_DATES_ERROR',
  AWS_INSERT_S3_DATES: 'AWS_INSERT_S3_DATES'
};



// WEBPACK FOOTER //
// ./src/constants/aws/s3Types.js